export const SET_FORECAST_FREE_CASH_FLOW = "SET_FORECAST_FREE_CASH_FLOW"